import styled from 'styled-components';
import { DarkGreySidely, DarkGreySidely2, SidelyBlack } from '../../../../styles/global/css/Utils';
import { getColorForEvolution, getColorForPercentage } from '../../../reports/utils';

const Container = styled.div``;

export const TableRowDnContainer = styled.div<{ dn: number }>`
    background-color: ${p => getColorForPercentage(p.dn, 1)};
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 80px;
    width: fit-content;
    border-radius: 60px;
    color: ${SidelyBlack};
    font-size: 13px;
    font-weight: 500;
`;

export const TableRowDnEvolutionContainer = styled.div<{ dnEvolution: number | null }>`
    color: ${p => getColorForEvolution(p.dnEvolution)};
    font-size: 11px;
    font-weight: 500;
	white-space: nowrap;
`;

interface TableRowProps {
	cursor?: string
	fontWeight?: string
	color?: string
	center?: boolean,
	padding?: string,
	overflow?: string
}

const TableRow = styled.div<TableRowProps>`
    width: 100%;
    overflow: ${p => p.overflow ? `${p.overflow}` : 'hidden'};
    font-size: 12px;
    line-height: 21px;
    text-overflow: ellipsis;
    cursor: ${p => p.cursor ? p.cursor : 'auto'};
    font-weight: ${p => p.fontWeight ? p.fontWeight : '400'};
    color: ${p => p.color ? p.color : DarkGreySidely2};
    ${p => p.padding ? `padding: ${p.padding};` : ''}
    ${p => p.center
		? `
        display: flex;
        align-items: center;
        padding: 0 5px;
    `
		: ''}

    &:focus-visible {
        border: none;
        outline: none;
    }

    &:focus {
        border: none;
        outline: none;
    }

    &:empty {
        &:not(:focus) {
            &:before {
                content: '-';
            }
        }
    }
`;

const TableRowTitle = styled(TableRow)`
    font-size: 12px;
    font-weight: 600;
    color: ${DarkGreySidely};
    cursor: pointer;
    width: 100%;
    text-wrap: nowrap;
    text-align: left;
`;

const TableRowStatusBackground = styled.div<{ noPointer?: boolean }>`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    width: 100%;
    ${p => p.noPointer ? '' : 'cursor: pointer;'}
`;

interface TableRowStatusProps {
	backgroundColor?: string
	noBackground?: boolean
}

const TableRowStatus = styled.div<TableRowStatusProps>`
	font-size: 11px !important;
	border: 1px solid ${p => p.backgroundColor ?? 'transparent'};
    background-color: ${p => p.noBackground ? 'transparent' : `color-mix(in oklab, ${p.backgroundColor ?? 'black'} 15%, transparent)`};
    border-radius: 8px;
    padding: 1px 7px;
    color: color-mix(in oklab, ${p => p.backgroundColor ?? 'white'}, black 18%);
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const RowComment = styled.p`
    margin: 0;
    font-weight: 400;
    color: ${DarkGreySidely2};
    font-size: 11px;
`;

export {
	Container,
	TableRow, TableRowStatus,
	TableRowStatusBackground, TableRowTitle
};
